module.exports = __webpack_public_path__ + "static/media/path0301.713148d5.jpg";